<!-- <div class="base" *ngIf="informationObj['vin_number'].value || informationObj['vehicle_item_code']">
  <div class="base__info ml-auto">
    <span class="base__infoItem mb-2"><span class="font-weight-medium">VIN No.:</span> {{ informationObj['vin_number'].value }}</span>
    <span class="base__infoItem"><span class="font-weight-medium">Item Code:</span> {{ informationObj['vehicle_item_code'] }}</span>
  </div>
</div> -->

<section class="vam_information_section options py-5">
  <div class="container">
    <form class="options__form" 
      [formGroup]="optionsForm"
      (submit)="saveData()">
      <div class="dualList mb-3">
        <div class="row mx-n2 h-100">
          <div class="col-md-6 px-2">
            <div class="dualList__listbox 
              dualList__valueBox"
              [class.cursor-not-allowed]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)">
              <ng-container *ngFor="let item of options">
                <div class="dualList__item" 
                  [class.untouchable]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)"
                  [attr.data-key]="item.key"
                  *ngIf="dataTypeChecker(item.data) === 'string'" 
                  (click)="selectItem($event, item, 'single')">
                  <span>
                    <ng-container *ngIf="lang == 'en'">
                      {{ item.title }}
                    </ng-container>
                    <ng-container *ngIf="lang == 'ar'">
                      {{ item.arabic_title }}
                    </ng-container>
                  </span>
                </div>

                <accordion class="dualList__item dualList__accordion p-0"
                  [class.untouchable]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)"
                  *ngIf="dataTypeChecker(item.data) === 'object'">
                  <accordion-group
                    [attr.data-key]="item.key">
                    <div class="dualList__accordionHeader" accordion-heading>
                      <span>
                        <ng-container *ngIf="lang == 'en'">
                          {{ item.title }}
                        </ng-container>
                        <ng-container *ngIf="lang == 'ar'">
                          {{ item.arabic_title }}
                        </ng-container>
                      </span>

                      <div class="dualList__selectAll">
                        <label class="vam_checkbox_container m-0">
                          {{ 'select_all' | translate }}
                          <input [disabled]="disableForm" type="checkbox" (change)="selectItem($event, item)">
                          <span class="vam_checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="dualList__item" 
                      *ngFor="let value of item.data;"
                      (click)="selectGroupedItem($event, value, item)">
                      <span>
                        <ng-container *ngIf="lang == 'en'">
                          {{ value.title }}
                        </ng-container>
                        <ng-container *ngIf="lang == 'ar'">
                          {{ value.arabic_title }}
                        </ng-container>
                      </span>
                    </div>
                  </accordion-group>
                </accordion>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6 px-2">
            <div class="dualList__listbox 
              dualList__selectedBox"
              [class.cursor-not-allowed]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)">
              <ng-container *ngFor="let item of dualList.selected">
                <div class="dualList__item" 
                  [class.untouchable]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)"
                  [attr.data-key]="item.key"
                  *ngIf="dataTypeChecker(item.data) === 'string'" 
                  (click)="deselectItem($event, item)">
                  <span>
                    <ng-container *ngIf="lang == 'en'">
                      {{ item.title }}
                    </ng-container>
                    <ng-container *ngIf="lang == 'ar'">
                      {{ item.arabic_title }}
                    </ng-container>
                  </span>
                </div>

                <accordion class="dualList__item dualList__accordion p-0"
                  [class.untouchable]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)"
                  *ngIf="dataTypeChecker(item.data) === 'object'">
                  <accordion-group [attr.data-key]="item.key">
                    <div class="dualList__accordionHeader" accordion-heading>
                      <span>
                        <ng-container *ngIf="lang == 'en'">
                          {{ item.title }}
                        </ng-container>
                        <ng-container *ngIf="lang == 'ar'">
                          {{ item.arabic_title }}
                        </ng-container>
                      </span>

                      <div class="dualList__selectAll">
                        <label class="vam_checkbox_container m-0">
                          {{ 'deselect_all' | translate }}
                          <input [disabled]="disableForm" type="checkbox" (change)="deselectItem($event, item)">
                          <span class="vam_checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="dualList__item" 
                      *ngFor="let value of item.data;"
                      (click)="deselectGroupedItem($event, value, item)">
                      <span>
                        <ng-container *ngIf="lang == 'en'">
                          {{ value.title }}
                        </ng-container>
                        <ng-container *ngIf="lang == 'ar'">
                          {{ value.arabic_title }}
                        </ng-container>
                      </span>
                    </div>
                  </accordion-group>
                </accordion>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group m-0">
            <textarea class="more_information" 
              name="more_information"
              formControlName="more_information"
              [placeholder]="'options.add_more_information' | translate"
              [readonly]="role === 'estimator' || role === 'qc' || role === 'purchasemanager'"></textarea>
          </div>
        </div>
      </div>
  
      <div class="options__btnGrp mt-4" *ngIf="role === 'evaluator' || role === 'admin' || editableRole.includes(role)">
        <div class="row mx-n2">
          <!-- <div class="col-sm-6 px-2 mb-3 mb-sm-0">
            <button type="button" class="btn btn__tertiary w-100">
              {{ 'close' | translate }}
            </button>
          </div> -->
          <div class="col-sm-6 px-2 mx-auto">
            <button *ngIf="!disableForm || (editableRole.includes(role) && disableForm)" type="submit" class="btn btn__primary w-100">
              {{ 'save' | translate }}
              <span class="spinner-grow 
                spinner-grow-sm 
                text-light ml-2" [hidden]="!submitLoaded">
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>

<loader [active]="loaded"></loader>

<!-- Modal -->
<ng-template #vehicleInfo>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{ informationObj ? informationObj['vehicle_item_code'] : ''}}
    </h4>
    <button type="button" 
      class="close"
      (click)="modalRef.hide()">
      <i class="bi bi-x"></i>
    </button>
  </div>
  <div class="modal-body optionsModal__body">
    <div class="optionsModal__infoHeader">
      <h4 class="fs fs__base">
        Vehicle info.
      </h4>
    </div>

    <div class="optionsModal__info">
      <div class="table-responsive">
        <table class="table optionsModal__table">
          <tbody>
            <tr>
              <th scope="row">Make</th>
              <td>{{ informationObj && informationObj['make_id'] ? informationObj['make_id'].value : 'N/A' }}</td>
              <th scope="row">Engine Size/ Cylinders</th>
              <td>{{ informationObj && informationObj['cyllinder_id'] ? informationObj['cyllinder_id'].value : 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">Model</th>
              <td>{{ informationObj && informationObj['model_id'] ? informationObj['model_id'].value : 'N/A' }}</td>
              <th scope="row">Type</th>
              <td>{{ informationObj && informationObj['trim_id'] ? informationObj['trim_id'].value : 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">Transmission</th>
              <td>{{ informationObj && informationObj['transmission_type_id'] ? informationObj['transmission_type_id'].value : 'N/A' }}</td>
              <th scope="row">Fuel</th>
              <td>{{ informationObj && informationObj['fuel_type_id'] ? informationObj['fuel_type_id'].value : 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">Body</th>
              <td>{{ informationObj && informationObj['body_type_id'] ? informationObj['body_type_id'].value : 'N/A' }}</td>
              <th scope="row">Gears</th>
              <td>{{ informationObj && informationObj['gear_id'] ? informationObj['gear_id'].value + ' Gears' : 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">H.P</th>
              <td>{{ informationObj && informationObj['power_id'] ? informationObj['power_id'].value : 'N/A' }}</td>
              <th scope="row">Doors</th>
              <td>{{ informationObj && informationObj['door_type_id'] ? informationObj['door_type_id'].value : 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">Seats</th>
              <td>{{ informationObj && informationObj['seat_id'] ? informationObj['seat_id'].value + ' Seats' : 'N/A' }}</td>
              <th scope="row">Year</th>
              <td>{{ informationObj && informationObj['model_year_id'] ? informationObj['model_year_id'].value : 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">ODO</th>
              <td>{{ informationObj && informationObj['odo'] ? informationObj['odo'].value + ' KM' : 'N/A' }}</td>
              <th scope="row"></th>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="optionsModal__btnGrp">
      <button type="button" 
        class="btn btn__primary mx-auto"
        (click)="redirectToFlag()">
        {{ 'done' | translate }}
      </button>
    </div>
  </div>
</ng-template>